import React, { useEffect, useState } from "react";
import "./portfolio.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import { useLocation, useNavigate, useParams } from "react-router";
import img from "../../interior_assets/porfolio/IMG1.jpeg";
import img1 from "../../interior_assets/porfolio/IMG2.jpeg";
import img2 from "../../interior_assets/porfolio/IMG3.jpeg";
import luxury1 from "../../interior_assets/Interior Website Images/Living Hall Design/Luxury Design 1.jpeg";
import luxury2 from "../../interior_assets/Interior Website Images/Living Hall Design/Luxury Design 2.jpg";
import luxury3 from "../../interior_assets/Interior Website Images/Living Hall Design/Luxury Design 3.jpg";
import modern1 from "../../interior_assets/Interior Website Images/Living Hall Design/Modern Design 1.jpeg";
import modern2 from "../../interior_assets/Interior Website Images/Living Hall Design/Modern Design 2.jpg";
import modern3 from "../../interior_assets/Interior Website Images/Living Hall Design/Modern Design 3.jpg";
import warm1 from "../../interior_assets/Interior Website Images/Living Hall Design/Warm Living Spaces 1.jpg";
import warm2 from "../../interior_assets/Interior Website Images/Living Hall Design/Warm Living Space 2.jpg";
import warm3 from "../../interior_assets/Interior Website Images/Living Hall Design/Warm Living Space 3.jpg";
import Green1 from "../../interior_assets/Interior Website Images/Balcony Design/Green Garden Seatout Balcony 1.jpg";
import Green2 from "../../interior_assets/Interior Website Images/Balcony Design/Green Garden Seatout Balcony 2.jpg";
import Green3 from "../../interior_assets/Interior Website Images/Balcony Design/Green Garden Seatout Balcony 3.jpg";
import small1 from "../../interior_assets/Interior Website Images/Balcony Design/Small & Space-Saving Balcony 1.jpg";
import small2 from "../../interior_assets/Interior Website Images/Balcony Design/Small & Space-Saving Balcony 2.jpg";
import small3 from "../../interior_assets/Interior Website Images/Balcony Design/Small & Space-Saving Balcony 3.jpg";
import cozy1 from "../../interior_assets/Interior Website Images/Balcony Design/Cozy Balcony With Seating Nook 1.jpg";
import cozy2 from "../../interior_assets/Interior Website Images/Balcony Design/Cozy Balcony With Seating Nook 2.jpg";
import cozy3 from "../../interior_assets/Interior Website Images/Balcony Design/Cozy Balcony With Seating Nook 3.jpg";
import Lshape1 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/L- Shaped Kitchen 1.jpg";
import Lshape2 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/L- Shaped Kitchen 2.jpg";
import Lshape3 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/L- Shaped Kitchen 3.jpg";
import Ushape1 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/U- Shaped Kitchen 1.jpg";
import Ushape2 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/U-Shaped Kitchen 2.jpg";
import Ushape3 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/U-Shaped Kitchen 3.jpg";
import straight1 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/Straight Kitchen 1.jpg";
import straight2 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/Straight Kitchen 2.jpg";
import straight3 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/Straight Kitchen 3.jpg";
import luxurydesign1 from "../../interior_assets/Interior Website Images/Dining Hall Design/Luxury Dining Hall 1.jpg";
import luxurydesign2 from "../../interior_assets/Interior Website Images/Dining Hall Design/Luxury Dining Hall 2.jpg";
import luxurydesign3 from "../../interior_assets/Interior Website Images/Dining Hall Design/Luxury Dining Hall 3.jpg";
import normaldesign1 from "../../interior_assets/Interior Website Images/Dining Hall Design/Normal Dining Hall 1.jpg";
import normaldesign2 from "../../interior_assets/Interior Website Images/Dining Hall Design/Normal Dining Hall 2.jpg";
import normaldesign3 from "../../interior_assets/Interior Website Images/Dining Hall Design/Normal Dining Hall 3.jpg";
import Traditionaldesign1 from "../../interior_assets/Interior Website Images/Dining Hall Design/Traditional Dining Hall 1.jpg";
import Traditionaldesign2 from "../../interior_assets/Interior Website Images/Dining Hall Design/Traditional Dining Hall 2.jpg";
import Traditionaldesign3 from "../../interior_assets/Interior Website Images/Dining Hall Design/Traditional Dining Hall 3.jpg";
import mordernmaster1 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Modern Master Bedroom 1.jpg";
import mordernmaster2 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Modern Master Bedroom 2.jpg";
import mordernmaster3 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Modern Master Bedroom 3.jpg";
import luxurymaster1 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Luxury Master Bedroom 1.jpg";
import luxurymaster2 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Luxury Master Bedroom 2.jpg";
import luxurymaster3 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Luxury Master Bedroom 3.jpg";
import Normalmaster1 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Normal Master Bedroom 1.jpg";
import Normalmaster2 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Normal Master Bedroom 2.jpg";
import Normalmaster3 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Normal Master Bedroom 3.jpg";
import Mwardrobe1 from "../../interior_assets/Interior Website Images/Wardrobe Design/Modular Wardrobe 1.jpg";
import Mwardrobe2 from "../../interior_assets/Interior Website Images/Wardrobe Design/Modular Wardrobe 2.jpg";
import Mwardrobe3 from "../../interior_assets/Interior Website Images/Wardrobe Design/Modular Wardrobe 3.jpg";
import slidewardrobe1 from "../../interior_assets/Interior Website Images/Wardrobe Design/Sliding Wardrobe Design 1.jpg";
import slidewardrobe2 from "../../interior_assets/Interior Website Images/Wardrobe Design/Sliding Wardrobe Design 2.jpg";
import slidewardrobe3 from "../../interior_assets/Interior Website Images/Wardrobe Design/Sliding Wardrobe Design 3.jpg";
import hingedwardrobe1 from "../../interior_assets/Interior Website Images/Wardrobe Design/Hinged Door Wardrobe 1.jpg";
import hingedwardrobe2 from "../../interior_assets/Interior Website Images/Wardrobe Design/Hinged Door Wardrobe 2.jpg";
import hingedwardrobe3 from "../../interior_assets/Interior Website Images/Wardrobe Design/Hinged Door Wardrobe 3.jpg";
import Mordernbath1 from "../../interior_assets/Interior Website Images/Bathroom Design/Modern Bathroom 1.jpg";
import Mordernbath2 from "../../interior_assets/Interior Website Images/Bathroom Design/Modern Bathroom 2.jpg";
import Mordernbath3 from "../../interior_assets/Interior Website Images/Bathroom Design/Modern Bathroom 3.jpg";
import compactbath1 from "../../interior_assets/Interior Website Images/Bathroom Design/Compact Small Space Bathroom 1.jpg";
import compactbath2 from "../../interior_assets/Interior Website Images/Bathroom Design/Compact Small Space Bathroom 2.jpg";
import compactbath3 from "../../interior_assets/Interior Website Images/Bathroom Design/Compact Small Space Bathroom 3.jpeg";
import luxurybath1 from "../../interior_assets/Interior Website Images/Bathroom Design/Luxury Spa - Style Bathroom 1.jpg";
import luxurybath2 from "../../interior_assets/Interior Website Images/Bathroom Design/Luxury Spa - Style Bathroom 2.jpg";
import luxurybath3 from "../../interior_assets/Interior Website Images/Bathroom Design/Luxury Spa - Style Bathroom 3.jpg";
import ledtv1 from "../../interior_assets/Interior Website Images/TV Unit Design/LED Backlit TV Unit 1.jpg";
import ledtv2 from "../../interior_assets/Interior Website Images/TV Unit Design/LED Backlit TV Unit 2.jpg";
import ledtv3 from "../../interior_assets/Interior Website Images/TV Unit Design/LED Backlit TV Unit 3.jpg";
import stonetv1 from "../../interior_assets/Interior Website Images/TV Unit Design/Marble Or Stone Finish Tv Unit 1.jpg";
import stonetv2 from "../../interior_assets/Interior Website Images/TV Unit Design/Marble Or Stone Finish Tv Unit 2.jpg";
import stonetv3 from "../../interior_assets/Interior Website Images/TV Unit Design/Marble Or Stone Finish Tv Unit 3.jpg";
import walltv1 from "../../interior_assets/Interior Website Images/TV Unit Design/Wall - Mounted TV Unit 1.jpg";
import walltv2 from "../../interior_assets/Interior Website Images/TV Unit Design/Wall - Mounted TV Unit 2.jpg";
import walltv3 from "../../interior_assets/Interior Website Images/TV Unit Design/Wall - Mounted TV Unit 3.jpg";
import studykid1 from "../../interior_assets/Interior Website Images/Kids Room Design/Study - Focused Kids Room 1.jpg";
import studykid2 from "../../interior_assets/Interior Website Images/Kids Room Design/Study - Focused Kids Room 2.jpg";
import studykid3 from "../../interior_assets/Interior Website Images/Kids Room Design/Study - Focused Kids Room 3.jpg";
import interactivekid1 from "../../interior_assets/Interior Website Images/Kids Room Design/Interactive Kids Room With Activity Zone 1.jpg";
import interactivekid2 from "../../interior_assets/Interior Website Images/Kids Room Design/Interactive Kids Room With Activity Zone 2.jpg";
import interactivekid3 from "../../interior_assets/Interior Website Images/Kids Room Design/Interactive Kids Room With Activity Zone 3.jpg";
import themedkid1 from "../../interior_assets/Interior Website Images/Kids Room Design/Themed Kids Room 1.jpg";
import themedkid2 from "../../interior_assets/Interior Website Images/Kids Room Design/Themed Kids Room 2.jpg";
import themedkid3 from "../../interior_assets/Interior Website Images/Kids Room Design/Themed Kids Room 3.jpg";
import poojadesign1 from "../../interior_assets/Interior Website Images/Prayer Hall Design/Pooja Mandir Design 1.jpg"
import poojadesign2 from "../../interior_assets/Interior Website Images/Prayer Hall Design/Pooja Mandir Design 2.jpeg"
import poojadesign3 from "../../interior_assets/Interior Website Images/Prayer Hall Design/Pooja Mandir Design 3.jpeg"
import islamicdesign1 from "../../interior_assets/Interior Website Images/Prayer Hall Design/Islamic Prayer Hall Design 1.jpeg"
import islamicdesign2 from "../../interior_assets/Interior Website Images/Prayer Hall Design/Islamic Prayer Hall Design 2.jpeg"
import islamicdesign3 from "../../interior_assets/Interior Website Images/Prayer Hall Design/Islamic Prayer Hall Design 3.jpeg"
import automobile1 from "../../interior_assets/Interior Website Images/Showroom Design/automobile1.jpeg"
import automobile2 from "../../interior_assets/Interior Website Images/Showroom Design/automobile2.jpeg"
import automobile3 from "../../interior_assets/Interior Website Images/Showroom Design/automobile3.jpeg"
import cosmatic1 from "../../interior_assets/Interior Website Images/Showroom Design/showroom images (1).jpg"
import cosmatic2 from "../../interior_assets/Interior Website Images/Showroom Design/showroom images (2).jpg"
import cosmatic3 from "../../interior_assets/Interior Website Images/Showroom Design/showroom images (3).jpg"
import modernfabric1 from "../../interior_assets/Interior Website Images/Showroom Design/modernfabric1.jpeg"
import modernfabric2 from "../../interior_assets/Interior Website Images/Showroom Design/modernfabric2.jpeg"
import modernfabric3 from "../../interior_assets/Interior Website Images/Showroom Design/modernfabric3.jpeg"
import Concrete from "../../interior_assets/Interior Website Images/Flooring gesign/Concrete Flooring.jpeg"
import Carpet from "../../interior_assets/Interior Website Images/Flooring gesign/Carpet Flooring.jpeg"
import Granite from "../../interior_assets/Interior Website Images/Flooring gesign/Granite Flooring.jpeg"
import Marble from "../../interior_assets/Interior Website Images/Flooring gesign/Marble Flooring.jpeg"
import Terrazzo from "../../interior_assets/Interior Website Images/Flooring gesign/Terrazzo Flooring.jpeg"
import titlesflooring from "../../interior_assets/Interior Website Images/Flooring gesign/Tiles Flooring.jpeg"
import vinyl from "../../interior_assets/Interior Website Images/Flooring gesign/Vinyl Flooring.jpeg"
import wooden from "../../interior_assets/Interior Website Images/Flooring gesign/Wooden Flooring.jpeg"
import Glossy from "../../interior_assets/Interior Website Images/Wall Paint Design/Glossy & Semi-Gloss Paint.jpeg";
import Marblefinish from "../../interior_assets/Interior Website Images/Wall Paint Design/Marble Finish Wall Paint.jpeg";
import Matte from "../../interior_assets/Interior Website Images/Wall Paint Design/Matte Finish Paint.jpeg";
import Satin from "../../interior_assets/Interior Website Images/Wall Paint Design/Satin &Eggshell Finish Paint.jpeg";
import stencil from "../../interior_assets/Interior Website Images/Wall Paint Design/Stencil Wall Paint.jpeg";
import metalic from "../../interior_assets/Interior Website Images/Wall Paint Design/Metallic wall paint.jpeg";
import venetianplaster from "../../interior_assets/Interior Website Images/Wall Paint Design/Venetian Plaster wall paint.jpeg";
import Texturedpaint from "../../interior_assets/Interior Website Images/Wall Paint Design/Textured Paint.jpeg";
import luxuryfalse from "../../interior_assets/Interior Website Images/False Ceiling Design/Luxury False Ceiling.jpg";
import officearea from "../../interior_assets/Interior Website Images/False Ceiling Design/Office Area False Ceiling Design.jpg";
import showroomsfalse from "../../interior_assets/Interior Website Images/False Ceiling Design/Showroom False Ceiling.jpg";



import Contactpopup from "../contact_popup/contactpopup";

const categories = [
  {
    name: "Living Hall Design",
    des: "Create the perfect living hall with designs that reflect your style and elevate your home.",
    subcategories: [
      {
        title: "Modern Design",
        title_description: "Sleek, minimalist designs with functional layouts and contemporary finishes to suit modern lifestyles.",
        images: [modern1, modern2, modern3],
      },
      {
        title: "Luxury Design",
        title_description: "Exquisite, high-end materials and elegant details that create a lavish and sophisticated atmosphere.",

        images: [luxury1, luxury2, luxury3],
      },
      {
        title: "Warm Living Space Design",
        title_description: "Inviting and cozy designs with soft tones, natural textures, and a homely ambiance for comfort and relaxation.",

        images: [warm1, warm2, warm3],
      },
    ],
  },
  {
    name: "Modular Kitchen Design",
    des: "Maximize functionality and style with tailored kitchen layouts designed to suit your space.",
    subcategories: [
      {
        title: "Straight Kitchen",
        title_description: "A sleek, space-efficient design ideal for smaller areas, with everything in a single line for easy access.",

        images: [straight1, straight2, straight3],
      },
      {
        title: "L-Shaped Kitchen",
        title_description: "Perfect for open spaces, this design offers ample counter space and storage, making cooking a breeze.",

        images: [Lshape1, Lshape2, Lshape3],
      },
      {
        title: "U-Shaped Kitchen",
        title_description: "A highly functional layout with three sides of cabinets, maximizing storage and workspace for larger kitchens.",

        images: [Ushape1, Ushape2, Ushape3],
      },
    ],
  },
  {
    name: "Dining Hall Design",
    des: "Create a dining space that suits your lifestyle, whether it's luxurious, casual, or traditional.",
    subcategories: [
      {
        title: "Normal Dining Hall",
        title_description: "Functional and stylish, offering a practical design that blends comfort and simplicity for everyday use.",

        images: [normaldesign1, normaldesign2, normaldesign3],
      },
      {
        title: "Luxury Dining Hall",
        title_description: "Elegantly designed with premium materials and sophisticated details to create a lavish dining experience.",

        images: [luxurydesign1, luxurydesign2, luxurydesign3],
      },
      {
        title: "Traditional Dining Hall",
        title_description: "Timeless and cozy, featuring classic furniture and warm tones to create an inviting and family-friendly atmosphere.",

        images: [Traditionaldesign1, Traditionaldesign2, Traditionaldesign3],
      },
    ],
  },
  {
    name: "Master Bedroom Design",
    des: "Design your sanctuary with a master bedroom that reflects your taste and offers ultimate comfort.",
    subcategories: [
      {
        title: "Modern Master Bedroom",
        title_description: "Sleek lines, minimalist decor, and contemporary finishes for a fresh, stylish retreat.",

        images: [mordernmaster1, mordernmaster2, mordernmaster3],
      },
      {
        title: "Luxury Master Bedroom",
        title_description: "Opulent designs with premium materials, elegant furnishings, and sophisticated details for a lavish escape.",

        images: [luxurymaster1, luxurymaster2, luxurymaster3],
      },
      {
        title: "Normal Master Bedroom",
        title_description: "A practical and comfortable design that balances style and function for everyday living.",

        images: [Normalmaster1, Normalmaster2, Normalmaster3],
      },
    ],
  },
  {
    name: "Wardrobe Design",
    des: "Tailored wardrobe solutions that blend functionality with style to fit your space.",
    subcategories: [
      {
        title: "Modular Wardrobe",
        title_description: "Customizable storage units that maximize space with flexible designs for every need.",

        images: [Mwardrobe1, Mwardrobe2, Mwardrobe3],
      },
      {
        title: "Sliding Door Wardrobe",
        title_description: "Space-saving wardrobes with smooth sliding doors, perfect for smaller rooms.",

        images: [slidewardrobe1, slidewardrobe2, slidewardrobe3],
      },
      {
        title: "Hinged Door Wardrobe",
        title_description: "Classic and sturdy design with outward-opening doors, ideal for spacious rooms with easy access.",

        images: [hingedwardrobe1, hingedwardrobe2, hingedwardrobe3],
      },
    ],
  },
  {
    name: "Bathroom Design",
    des: "Transform your bathroom into a functional and stylish retreat.",
    subcategories: [
      {
        title: "Modern Bathroom",
        title_description: "Clean lines, contemporary fixtures, and minimalist design for a sleek and fresh look.",

        images: [Mordernbath1, Mordernbath2, Mordernbath3],
      },
      {
        title: "Luxury Spa-Style Bathroom",
        title_description: "Opulent features, indulgent finishes, and soothing elements to create a relaxing, spa-like experience.",

        images: [luxurybath1, luxurybath2, luxurybath3],
      },
      {
        title: "Compact Small-Space Bathroom",
        title_description: "Efficient, space-saving designs that maximize functionality without compromising on style",

        images: [compactbath1, compactbath2, compactbath3],
      },
    ],
  },
  {
    name: "Balcony Design",
    des: "Create a perfect outdoor space with designs that match your lifestyle.",
    subcategories: [
      {
        title: "Green Garden Sit-out Balcony",
        title_description: "A lush, natural retreat with plants and seating for a peaceful outdoor experience.",

        images: [Green1, Green2, Green3],
      },
      {
        title: "Small & Space-Saving Balcony",
        title_description: "Clever, compact designs that make the most of limited space without sacrificing style.",

        images: [small1, small2, small3],
      },
      {
        title: "Cozy Balcony with Seating Nook",
        title_description: "A warm, inviting space with a comfortable seating area for relaxation and enjoying the outdoors.",

        images: [cozy1, cozy2, cozy3],
      },
    ],
  },
  {
    name: "TV Unit Design",
    des: "Stylish and functional designs to enhance your living room.",
    subcategories: [
      {
        title: "Wall-Mounted TV Unit",
        title_description: "Sleek and modern, this design saves space while giving a clean, floating look to your TV area.",

        images: [walltv1, walltv2, walltv3],
      },
      {
        title: "LED Backlit TV Unit",
        title_description: "A contemporary design with LED lighting to add ambiance and highlight your TV unit in style.",

        images: [ledtv1, ledtv2, ledtv3],
      },
      {
        title: "Marble or Stone Finish TV Unit",
        title_description: "Luxurious and sophisticated, with premium marble or stone finishes that add elegance and durability to your space.",

        images: [stonetv1, stonetv2, stonetv3],
      },
    ],
  },
  {
    name: "Kids Room Design",
    des: "Create a fun, functional, and inspiring space for your child.",
    subcategories: [
      {
        title: "Study-Focused Kids' Room",
        title_description: "Designed with ample storage, a comfortable study area, and a calming ambiance to promote learning and focus.",

        images: [studykid1, studykid2, studykid3],
      },
      {
        title: "Themed Kids' Room",
        title_description: "Fun, imaginative designs based on your child’s favorite themes, from superheroes to fantasy worlds, for a playful environment.",

        images: [themedkid1, themedkid2, themedkid3],
      },
      {
        title: "Interactive Kids’ Room with Activity Zone",
        title_description: "An engaging space with designated areas for learning, play, and creativity, encouraging interaction and exploration.",

        images: [interactivekid1, interactivekid2, interactivekid3],
      },
    ],
  }, {
    name: "Prayer Hall Design",
    des: "Create a serene and sacred space for worship and reflection.",
    subcategories: [
      {
        title: "Pooja Mandir Design",
        title_description: "Elegant and spiritual designs for a dedicated space for Hindu rituals, featuring traditional or modern elements, depending on your style.",

        images: [poojadesign1, poojadesign2, poojadesign3],
      },
      {
        title: "Islamic Prayer Hall",
        title_description: "Peaceful and serene designs with specific features like Qibla alignment, intricate detailing, and a calm, reflective atmosphere for prayer.",

        images: [islamicdesign1, islamicdesign2, islamicdesign3],
      },

    ],
  },
  {
    name: "False Ceiling Design",
    des: "Enhance your space with stylish, functional false ceiling solutions.",
    subcategories: [
      {
        title: "Commercial Luxury False Ceiling",
        title_description: "Opulent designs with high-end materials and intricate patterns that elevate the overall elegance of your space.",

        images: [luxuryfalse],
      },
      {
        title: "Showrooms False Ceiling",
        title_description: "Modern and sleek designs with lighting elements that create a stylish, attention-grabbing atmosphere for retail spaces.",

        images: [showroomsfalse],
      },
      {
        title: "Office Area False Ceiling",
        title_description: "Functional and professional designs that offer sound insulation, lighting solutions, and a clean, organized look for office environments.",

        images: [officearea],
      },
    ],
  },
  {
    name: "Wall Paint Design",
    des: "Transform your walls with a range of paint finishes to suit every space and style.",
    subcategories: [
      {
        title: "Textured Paint",
        title_description: "Adds depth and dimension to your walls with a variety of unique textures, creating a distinctive, artistic look.",

        images: [Texturedpaint],
      },
      {
        title: "Matte Finish Pain",
        title_description: "A smooth, non-reflective finish that offers a sophisticated and subtle look, perfect for a modern, minimalist aesthetic.",

        images: [Matte],
      },
      {
        title: "Satin & Eggshell Finish Paint",
        title_description: "Satin offers a soft sheen, while eggshell provides a smooth, low-gloss finish, ideal for durability and a soft look.",

        images: [Satin],
      },
      {
        title: "Glossy & Semi-Gloss Paint",
        title_description: "High-shine finishes that are easy to clean, perfect for areas requiring a sleek, reflective surface and added durability.",

        images: [Glossy],
      },
      {
        title: "Metallic Wall Paint",
        title_description: "Gives walls a stunning reflective surface, adding a touch of glamour and sophistication with metallic sheens.",

        images: [metalic],
      },
      {
        title: "Marble Finish Wall Paint",
        title_description: "A luxurious, marble-like effect for walls, offering a sophisticated and elegant appearance with textured depth.",

        images: [Marblefinish],
      },
      {
        title: "Venetian Plaster",
        title_description: "A smooth, polished finish with a subtle sheen, giving walls an elegant, timeless look with depth and texture.",

        images: [venetianplaster],
      },
      {
        title: "Stencil Wall Paint",
        title_description: "Creative designs and patterns applied using stencils, perfect for adding a personal touch and unique charm to your walls.",

        images: [stencil],
      },
    ],
  },
  {
    name: "Flooring Design",
    des: "Choose the perfect flooring to enhance the beauty and functionality of your space.",
    subcategories: [
      {
        title: "Marble Flooring",
        title_description: "Luxurious and timeless, marble offers elegance and durability with its unique veining and smooth finish.",

        images: [Marble],
      },
      {
        title: "Granite Flooring",
        title_description: "Strong, durable, and sleek, granite provides a high-end, polished look with minimal maintenance.",

        images: [Granite],
      },
      {
        title: "Wooden Flooring",
        title_description: "Warm and natural, wooden floors bring richness and charm, available in various finishes and textures.",

        images: [wooden],
      },
      {
        title: "Tile Flooring",
        title_description: "Versatile and easy to maintain, tiles come in various styles, from classic to contemporary, offering durability and style.",

        images: [titlesflooring],
      },
      {
        title: "Vinyl Flooring",
        title_description: "Affordable and versatile, vinyl provides comfort and resilience with a variety of patterns and finishes.",

        images: [vinyl],
      },
      {
        title: "Terrazzo Flooring",
        title_description: "A unique, decorative flooring option made from chips of marble, quartz, or granite, creating a bold and vibrant look.",

        images: [Terrazzo],
      },
      {
        title: "Concrete Flooring",
        title_description: "Industrial and modern, concrete offers a minimalistic, durable surface that can be polished or textured.",

        images: [Concrete],
      },
      {
        title: "Carpet Flooring",
        title_description: "Soft and cozy, carpet flooring adds warmth and texture, available in a wide range of colors and patterns for a comfortable feel.",

        images: [Carpet],
      },
    ],
  },
  {
    name: "Showroom Design",
    des: "Create a striking and functional showroom that enhances your brand and attracts customers.",
    subcategories: [
      {
        title: "Compact Cosmetic Showroom",
        title_description: "Elegant and modern designs that highlight beauty products with well-lit displays, creating an inviting and luxurious shopping experience.",

        images: [cosmatic1, cosmatic2, cosmatic3],
      },
      {
        title: "Modern Fabric Showroom",
        title_description: "Stylish and organized layouts with versatile displays to showcase fabrics in a visually appealing and accessible way for customers.",

        images: [modernfabric1, modernfabric2, modernfabric3],
      },
      {
        title: "Automobile Showroom",
        title_description: "Sleek, spacious designs with optimal lighting and layout to showcase vehicles in an open, professional, and engaging environment.",

        images: [automobile1, automobile2, automobile3],
      },
    ],
  },

];

function Portfoliopagemain() {


  const [showpopup, setShowpopup] = useState(false);

  const openPopup = () => {
    setShowpopup(true);
  }

  const closePopup = () => {
    setShowpopup(false);
  }

  
  const { category, title } = useParams(); // Get values from URL
  const navigate = useNavigate();

  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(categories[0].subcategories[0]);
  const [visibleIndex, setVisibleIndex] = useState(0);


  var settings = {
    dots: true,
    infinite: selectedSubcategory.images.length > 1,
    // infinite:true,
     // Disable infinite loop for one image
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    const foundCategory = categories.find((cat) => cat.name === category) || categories[0];
    setSelectedCategory(foundCategory);

    const foundSubcategory = foundCategory.subcategories.find((sub) => sub.title === title) || foundCategory.subcategories[0];
    setSelectedSubcategory(foundSubcategory);
  }, [category, title]);

  const handleCategoryChange = (newCategory) => {
    const newTitle = newCategory.subcategories[0].title; // Default to first subcategory
    navigate(`/portfoliopage/${newCategory.name}/${newTitle}`);
  };

  const handleSubcategoryChange = (newTitle) => {
    navigate(`/portfoliopage/${selectedCategory.name}/${newTitle}`);
  };

  const handleNextButtons = () => {
    if (visibleIndex + 8 < categories.length) {
      setVisibleIndex((prev) => prev + 1);
    }
  };

  const handlePrevButtons = () => {
    if (visibleIndex > 0) {
      setVisibleIndex((prev) => prev - 1);
    }
  };

  return (
    <>
      <Navbar />
      <section style={{ marginTop: "130px" }}>
        <div className="design-details">
          <h3>{selectedCategory.name}</h3>
          <p>{selectedCategory.des}</p>
        </div>

        {/* Category Buttons */}
        <div className="button-slider">
          <button className="slider-nav" onClick={handlePrevButtons} disabled={visibleIndex === 0}>
            <FaChevronLeft />
          </button>

          <div className="design-button">
            {categories.slice(visibleIndex, visibleIndex + 8).map((cat) => (
              <button
                key={cat.name}
                className={cat.name === selectedCategory.name ? "active" : ""}
                onClick={() => handleCategoryChange(cat)}
              >
                {cat.name}
              </button>
            ))}
          </div>

          <button className="slider-nav" onClick={handleNextButtons} disabled={visibleIndex + 8 >= categories.length}>
            <FaChevronRight />
          </button>
        </div>

        {/* Subcategory Buttons */}
        <div className="design-button-sub">
          {selectedCategory.subcategories.map((sub) => (
            <button
              key={sub.title}
              className={sub.title === selectedSubcategory.title ? "active" : ""}
              onClick={() => handleSubcategoryChange(sub.title)}
            >
              {sub.title}
            </button>
          ))}
        </div>


        <div className="image-wrapper">

          {selectedSubcategory.images.map((src, idx) => (
            <div key={idx} className="image-div-container">

              <img src={src} alt={selectedSubcategory.title} className="selected-image" />
            </div>
          ))}
        </div>

        {/* Display Images */}


        <div className="image-wrapper-mobile">
       
            <Slider {...settings}>
              {selectedSubcategory.images.map((src, idx) => (
                <div key={idx} className="image-div-container">
                  <img src={src} alt={selectedSubcategory.title} className="selected-image" />
                </div>
              ))}
            </Slider>
       

        </div>
        <p style={{ textAlign: "center", marginTop: "20px", marginLeft: "5px" }}>{selectedSubcategory.title_description}</p>

        {/* <h4>Model Name:{selectedSubcategory.title}</h4> */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"center", width:"100%",marginBottom:"50px"}}>
<button className="whyChooseus_whyChooseBtn__GTv3X btn btnPrimery mxAuto main-enquiry-button" 
                        style={{ background: "#e6c6c0", fontWeight: 500, color:"#cf5b55" }} onClick={openPopup} >
                    Book Free Consultation
                </button>
                </div>

      </section>
      <Footer />
      {showpopup && <Contactpopup onClose={closePopup} />}


    </>
  );
}

export default Portfoliopagemain;
